import React from "react";
import { useFavoriteEvents } from "../../common/favorite-events/FavoriteEventsProvider";
import { usePrematchData } from ".././PrematchDataFetcher";
import { getConfiguration, getPrincipaleOPrimoGruppo } from "../../data/utils";
import { useFetchNew } from "../../data/fetch/useFetch";
import { parseTournamentData } from "../../data/parseTournamentData";
import Tournament from "./Tournament";
import Img from "../../common/Img";
import EventPreview from "../EventPreview";

function TournamentFetcher(props) {
    const prematchData = usePrematchData();
    const conf = getConfiguration();

    const tournament = props.data;
    const aggId = getPrincipaleOPrimoGruppo(tournament.aggregate).idAggregata;

    const [isLoading, isError, data] = useFetchNew(conf.api.getTorneoCentrale, {
        sportId: tournament.sportRef,
        categoryId: tournament.categoryRef,
        tournamentId: tournament.id,
        idAggregata: aggId
    }, (data) =>
        parseTournamentData(prematchData, data, tournament.uniqueId, aggId, false, true)
    );

    if (isLoading || isError) {
        return null;
    }

    return props.renderItem(data);
}

export default function FavoriteEvents(props) {
    const favorites = useFavoriteEvents();
    const prematchData = usePrematchData();

    if (favorites == null || Object.keys(favorites).length === 0) {
        return null;
    }

    const eventsByTournament = new Map();
     Object.keys(favorites).forEach(id => {
        const regex = /(?<tournamentId>-?\d+_-?\d+_-?\d+)_(?<pal>-?\d+)_(?<avv>-?\d+)/;
        if (!regex.test(id)) {
            return null;
        }
        const groups = regex.exec(id).groups;
        const tournamentId = groups.tournamentId;

        if (!eventsByTournament.has(tournamentId)) {
            eventsByTournament.set(tournamentId, []);
        }

        const [pal, avv] = [parseInt(groups.pal, 10), parseInt(groups.avv, 10)]
        eventsByTournament.get(tournamentId).push({pal, avv});
    });

    const tournaments = [];
    eventsByTournament.forEach((events, tournamentId) => {
        const t = prematchData.tournamentByUniqueId[tournamentId];
        if (t == null) {
            return;
        }

        tournaments.push(
            <TournamentFetcher key={t.uniqueId} data={t} renderItem={(data) => {
                const filteredEvents = [];
                events.forEach(te => {
                    const e = data.events.find(e => e.pal === te.pal && e.avv === te.avv);
                    if (e == null) {
                        return null;
                    }
                    
                    filteredEvents.push(e);
                });

                if (filteredEvents.length > 0) {
                    if (props.preview) {
                        return filteredEvents.map(e =>
                            <EventPreview key={e.uniqueId} data={e} showFullDesc={true} />
                        );
                    }

                    return (
                        <Tournament data={{...data, events: filteredEvents}} />
                    );
                }

                return null;
            }} />
        );
    });

    if (tournaments.length === 0) {
        return null;
    }

    return (
        <>
            <div className="c_44">
                <Img className="c_44_1" src="daily_flash_odds.svg" height="16px" width="16px" />
                <div className="c_44_2">{'Fixed events'}</div>
            </div>
            <div className="c_62">
                {tournaments}
            </div>
        </>
    );
}
